import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getUserDetailsByUserId,
  getFormVerifyDetailsByStudentId
} from "../../actions";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import AdmissionFormList from "./AdmissionFormList";
import AcademicProfile from "./AcademicInfo";
import AdmissionProfile from "./AdmissionProfile";
import AdmissionVerifyPrint from "./AdmissionVerifyPrint";
import AdmissionPrint from "./AdmissionPrint";
import "react-tabs/style/react-tabs.css";

class AdmissionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    this.props.getUserDetailsByUserId(this.props.auth.userId);
    this.props.getFormVerifyDetailsByStudentId(
      this.props.match.params.FormId || 0,
      this.props.auth.userId
    );
  }
  render() {
    return (
      <div className="container">
        <Tabs
          className="custom-tabs"
          selectedIndex={parseInt(this.props.match.params.TabIndex, 10)}
          onSelect={TabIndex => this.setState({ TabIndex })}
        >
          <TabList>
            <Tab>
              {parseInt(this.props.match.params.TabIndex, 10) === 0 && (
                <div className="step">
                  <i className="fa fa-graduation-cap icon" aria-hidden="true" />
                  <div className="content">
                    <div className="title">Apply for Admission</div>
                    <div className="description">Select Academic Program</div>
                  </div>
                </div>
              )}
              {parseInt(this.props.match.params.TabIndex, 10) !== 0 && (
                <Link
                  to={`/Account/StudentAccount/AdmissionForm/0/${
                    this.props.match.params.FormId
                  }`}
                >
                  <div className="step">
                    <i
                      className="fa fa-graduation-cap icon"
                      aria-hidden="true"
                    />
                    <div className="content">
                      <div className="title">Apply for Admission</div>
                      <div className="description">Select Academic Program</div>
                    </div>
                  </div>
                </Link>
              )}
            </Tab>

            <Tab
              disabled={!this.props.match.params.FormId ? true : false}
              disabledClassName="disableTab"
            >
              {this.props.match.params.FormId ? (
                <Link
                  to={`/Account/StudentAccount/AdmissionForm/1/${
                    this.props.match.params.FormId
                  }`}
                >
                  <div className="step">
                    <i className="fa fa-user-o icon" aria-hidden="true" />
                    <div className="content">
                      <div className="title">Personal Details</div>
                      <div className="description">Fill Personal Details</div>
                    </div>
                    <i
                      className={
                        this.props.userDetails.IsFilled === 1
                          ? "fa fa-check-circle isfilledCheck"
                          : "fa fa-check-circle"
                      }
                      aria-hidden="true"
                    />
                  </div>
                </Link>
              ) : (
                <div className="step">
                  <i className="fa fa-user-o icon" aria-hidden="true" />
                  <div className="content">
                    <div className="title">Personal Details</div>
                    <div className="description">Fill Personal Details</div>
                  </div>
                  <i
                    className={
                      this.props.userDetails.IsFilled === 1
                        ? "fa fa-check-circle isfilledCheck"
                        : "fa fa-check-circle"
                    }
                    aria-hidden="true"
                  />
                </div>
              )}
            </Tab>

            <Tab
              disabled={
                this.props.match.params.FormId &&
                this.props.userDetails.IsFilled === 1
                  ? false
                  : true
              }
              disabledClassName="disableTab"
            >
              {this.props.match.params.FormId &&
              this.props.userDetails.IsFilled === 1 ? (
                <Link
                  to={`/Account/StudentAccount/AdmissionForm/2/${
                    this.props.match.params.FormId
                  }`}
                >
                  <div className="step">
                    <i className="fa fa-book icon" aria-hidden="true" />
                    <div className="content">
                      <div className="title">Academic Profile</div>
                      <div className="description">Fill Academic Details</div>
                    </div>
                    <i
                      className={
                        this.props.userDetails.IsFilled === 1
                          ? "fa fa-check-circle isfilledCheck"
                          : "fa fa-check-circle"
                      }
                      aria-hidden="true"
                    />
                  </div>
                </Link>
              ) : (
                <div className="step">
                  <i className="fa fa-book icon" aria-hidden="true" />
                  <div className="content">
                    <div className="title">Academic Profile</div>
                    <div className="description">Fill Academic Details</div>
                  </div>
                  <i
                    className={
                      this.props.userDetails.IsFilled === 1
                        ? "fa fa-check-circle isfilledCheck"
                        : "fa fa-check-circle"
                    }
                    aria-hidden="true"
                  />
                </div>
              )}
            </Tab>

            <Tab
              disabled={
                this.props.match.params.FormId &&
                this.props.userDetails.IsFilled === 1 &&
                this.props.admissionVerifyDetails.length > 0
                  ? false
                  : true
              }
              disabledClassName="disableTab"
            >
              {this.props.match.params.FormId &&
              this.props.userDetails.IsFilled === 1 &&
              this.props.admissionVerifyDetails.length > 0 ? (
                <Link
                  to={`/Account/StudentAccount/AdmissionForm/3/${
                    this.props.match.params.FormId
                  }`}
                >
                  <div className="step">
                    <i
                      className="fa fa-check-square-o icon"
                      aria-hidden="true"
                    />
                    <div className="content">
                      <div className="title">Verify Detail</div>
                      <div className="description">Verify Details</div>
                    </div>
                  </div>
                </Link>
              ) : (
                <div className="step">
                  <i className="fa fa-check-square-o icon" aria-hidden="true" />
                  <div className="content">
                    <div className="title">Verify Detail</div>
                    <div className="description">Verify Details</div>
                  </div>
                </div>
              )}
            </Tab>

            <Tab
              disabled={
                this.props.match.params.FormId &&
                this.props.userDetails.IsFilled === 1 &&
                this.props.admissionVerifyDetails.length > 0
                  ? false
                  : true
              }
              disabledClassName="disableTab"
            >
              {this.props.match.params.FormId &&
              this.props.userDetails.IsFilled === 1 &&
              this.props.admissionVerifyDetails.length > 0 ? (
                <Link
                  to={`/Account/StudentAccount/AdmissionForm/4/${
                    this.props.match.params.FormId
                  }`}
                >
                  <div className="step">
                    <i className="fa fa-print icon" aria-hidden="true" />
                    <div className="content">
                      <div className="title">Print Detail</div>
                      <div className="description">Print Details</div>
                    </div>
                  </div>
                </Link>
              ) : (
                <div className="step">
                  <i className="fa fa-print icon" aria-hidden="true" />
                  <div className="content">
                    <div className="title">Print Detail</div>
                    <div className="description">Print Details</div>
                  </div>
                </div>
              )}
            </Tab>
          </TabList>

          <TabPanel>
            <div className="custom-panel">
              <AdmissionFormList FormId={this.props.match.params.FormId} />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="custom-panel">
              <AdmissionProfile FormId={this.props.match.params.FormId} />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="custom-panel">
              <AcademicProfile FormId={this.props.match.params.FormId} />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="custom-panel">
              <AdmissionVerifyPrint FormId={this.props.match.params.FormId} />
            </div>
          </TabPanel>
          <TabPanel>
            <div className="custom-panel">
              <AdmissionPrint FormId={this.props.match.params.FormId} />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}
function mapStateToProps({ auth, userDetails, admissionVerifyDetails }) {
  return {
    auth,
    userDetails,
    admissionVerifyDetails
  };
}
export default connect(
  mapStateToProps,
  { getUserDetailsByUserId, getFormVerifyDetailsByStudentId }
)(AdmissionForm);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AdmissionForm.js